import { render, staticRenderFns } from "./RevisionsDashboardList.vue?vue&type=template&id=535d913e"
import script from "./RevisionsDashboardList.vue?vue&type=script&lang=js"
export * from "./RevisionsDashboardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports